import React, { useState } from 'react';
import "./Solution.css";
import useIntersectionObserver from "../customHooks/useIntersectionObserver.js";
const tabsData = [
    {
        id: 0,
        title: "Data-Driven Backlog Prioritization ",
        shortDesc: " Refines and reorders the backlog using advanced prioritization models like WSJF and MoSCoW to focus on what matters most. ",
        longDesc: " Refines and reorders the backlog using advanced prioritization models like WSJF and MoSCoW to focus on what matters most. ",
        points: [
            { strong: "Smart task prioritization:", text: " Suggests optimal sequence based on dependencies, effort, and impact" },
            { strong: "Flags unclear items:", text: " Flags ambiguous or oversized items for further clarification" }
        ],
        image: "https://www.akira.ai/hubfs/Imported%20images/task-breakdown.svg",
    },
    {
        id: 1,
        title: "Intelligent Sprint Planning Facilitation",
        shortDesc: " Generates draft sprint goals, suggests task breakdowns, and aligns estimates with team capacity",
        longDesc: " Generates draft sprint goals, suggests task breakdowns, and aligns estimates with team capacity",
        points: [
            { strong: "Team-based sizing:", text: " Enables collaborative estimation using planning poker and t-shirt sizing." },
            { strong: "Smart workload balancing:", text: " Balances workload based on availability, skills, and historical performance" }
        ],
        image: "https://www.akira.ai/hubfs/Imported%20images/seamless-integration-with-ecosystems.svg",
    },
    {
        id: 2,
        title: "Real-Time Daily Scrum Automation ",
        shortDesc: " Compiles structured daily updates by synthesizing data from tools like Jira and Slack",
        longDesc: " Compiles structured daily updates by synthesizing data from tools like Jira and Slack",
        points: [
            { strong: "Focused work planning:", text: "Creates focused daily agendas and visual progress summaries" },
            { strong: "Issue alerting:", text: "Detects and surfaces blockers, prompting timely action" }
        ],
        image: "https://www.akira.ai/hubfs/Imported%20images/real-time-data-processing.svg",
    },
    {
        id: 3,
        title: "Proactive Impediment Resolution",
        shortDesc: " Continuously identifies, categorizes, and tracks impediments to maintain sprint momentum",
        longDesc: " Continuously identifies, categorizes, and tracks impediments to maintain sprint momentum. ",
        points: [
            { strong: "Automated blocker tracking:", text: "Manages the full blocker lifecycle with automated follow-ups" },
            { strong: "Swift issue notification:", text: "Notifies relevant team members for swift resolution" }
        ],
        image: "https://www.akira.ai/hubfs/Imported%20images/multi-agent-collaboration.svg",
    }
];

const Solution = () => {
    const [activeTab, setActiveTab] = useState(0);
    const [ref, isVisible] = useIntersectionObserver({ threshold: 0.1 });
    return (
        <section className={`use-cases-section ${isVisible ? "section-animation" : ""}`}
            ref={ref}
            id="two">
            <div className="container">
                <div className='use-case-wrapper'>
                    <div className="content-tag">
                        <h2 className='colored-text'>Use Cases</h2>
                    </div>
                    <div className="section-heading">
                        <h2>Accelerating Project Management with Agent Scrum </h2>
                        <p> Discover how Agent Scrum enhances agile delivery through intelligent, context-aware automation</p>
                    </div>

                    <div className="second-tabs-switch-wrapper">
                        <div className="second-tab-switch-body-wrapper">
                            {/* Tabs */}
                            <div className="tabs">
                                {tabsData.map((tab, index) => (
                                    <div
                                        key={tab.id}
                                        className={activeTab === index ? "active" : ""}
                                        onClick={() => setActiveTab(index)}
                                        style={{ cursor: "pointer" }}
                                    >
                                        <span>{`0${tab.id + 1}`}</span>
                                        <h4>{tab.title}</h4>
                                        <p>{tab.shortDesc}</p>
                                    </div>
                                ))}
                            </div>

                            {/* Tab Content */}
                            {tabsData.map((tab, index) => (
                                <div
                                    key={tab.id}
                                    className={`second-tab-switch-body ${activeTab === index ? "active" : ""}`}
                                    style={{ display: activeTab === index ? "block" : "none" }}
                                >
                                    <div className="second-tab-switch-content-body">
                                        <div className="tab-switch-text">
                                            <h3><span>{`0${tab.id + 1}`}</span><br />{tab.title}</h3>
                                            <p>{tab.longDesc}</p>
                                            <ul>
                                                {tab.points.map((point, idx) => (
                                                    <li key={idx}>
                                                        <img src="https://www.akira.ai/hubfs/blue-checkmark-round.svg" alt="checkmark" />
                                                        <p><strong>{point.strong}</strong> {point.text}</p>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                        <div className="tab-switch-image">
                                            <img
                                                src={tab.image}
                                                alt={tab.title}
                                                loading="lazy"
                                                width="416"
                                                height="396"
                                                style={{ maxWidth: "100%", height: "auto" }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Solution;
